import type { GameRow } from '../types';
import type { UsPlayerTarget } from '@/lib/polymarketUs/playerTarget';
import { usStatLabel } from '@/lib/polymarketUs/statLabels';

/** No N+ conversion: the title is source wording, the strike is native. */
export function usPlayerPanelGame(base: GameRow, target: UsPlayerTarget, title?: string | null): GameRow {
  const caption = title ?? `${target.metadata.player} · ${usStatLabel(target.metadata.stat)}${target.line === null ? '' : ` · Line ${target.line}`}`;
  return { ...base, key: `${base.key}|us-player|${target.marketSlug}`, usPlayerProp: target,
    awayName: caption, homeName: caption, kalshi: null, polymarket: null, spreadOutcome: undefined,
    finalWinnerSide: null };
}
